'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merge = merge;
exports.bindMethod = bindMethod;
exports.bindMethods = bindMethods;
var get = exports.get = require('lodash.get');
var has = exports.has = require('lodash.has');
var omit = exports.omit = require('lodash.omit');
var omitBy = exports.omitBy = require('lodash.omitby');
var pick = exports.pick = require('lodash.pick');
var set = exports.set = require('lodash.set');
var stringify = exports.stringify = require('json-stringify-safe');
var traverse = exports.traverse = require('traverse');
var values = exports.values = require('lodash.values');

var _merge = require('lodash.merge');
function merge() {
  var result = {};
  _merge.apply(undefined, [result].concat(Array.prototype.slice.call(arguments)));
  return result;
}
var mergeDeep = exports.mergeDeep = merge;

function bindMethod(object, methodName) {
  object[methodName] = object[methodName].bind(object);
}

function bindMethods(object, methodNames) {
  methodNames.forEach(function (methodName) {
    bindMethod(object, methodName);
  });
}

exports.default = {
  bindMethod: bindMethod,
  bindMethods: bindMethods,
  get: get,
  has: has,
  merge: merge,
  mergeDeep: mergeDeep,
  omit: omit,
  omitBy: omitBy,
  pick: pick,
  set: set,
  stringify: stringify,
  traverse: traverse,
  values: values
};